import React, { useState } from 'react'

export default function Table({ headingsObj, DataArray, includeView = false, includeDelete = false,includeEdit = false, handleViewFn }) {
    return (
        <>
            {
                DataArray && DataArray?.length > 0 ?
                    <div className='' style={{ boxShadow: '4px 4px 15px 3px #e2e2e2', borderRadius: '6px' }}>
                        <table className="table custonTable">
                            <thead>
                                {
                                    headingsObj && Object.keys(headingsObj)?.length > 0 ?
                                        <tr>
                                            {
                                                Object.values(headingsObj)?.map((value, index) => {
                                                    return (
                                                        <th key={index}>{value}</th>
                                                    )
                                                })
                                            }
                                            {
                                                includeView || includeDelete ?
                                                    <th>Actions</th>
                                                    : ''}
                                        </tr>
                                        : ''}
                            </thead>
                            <tbody>
                                {DataArray.map((row, i) => (
                                    <tr key={i}>
                                        {Object.keys(headingsObj).map((key, index) => (
                                            <td key={index}>
                                                {row[key] !== undefined ? row[key] : '-'}
                                            </td>
                                        ))}
                                        <td>
                                            {
                                                includeView ?
                                                    <i class="fa fa-eye" aria-hidden="true" onClick={() => handleViewFn("view", row)}></i>
                                                    : ''}
                                            {
                                                includeEdit ?
                                                    <>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <i class="fa fa-pencil-square-o" aria-hidden="true" onClick={() => handleViewFn("edit", row)}></i>
                                                    </>
                                                    : ''}
                                            {
                                                includeDelete ?
                                                    <>
                                                        &nbsp;&nbsp;&nbsp;
                                                        <i class="fa fa-trash" aria-hidden="true" onClick={() => handleViewFn("delete", row)}></i>
                                                    </>
                                                    : ''}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    : ''}
        </>
    )
}
